import React, { FormEvent, useState } from 'react'
import { uploadSupplierData, toastSuccess } from '../../api'
import { InsufficientPermissions, Loading } from '../common'
import { getAuthUser } from '../../helpers'

import defineAbilityFor from './defineAbility'

interface Summary {
    filename: string
    duplicateCount: number
    newSupplierCount: number
    missingPhoneCount: number
    totalSuppliers: number
}

export const SupplierDataUpload = () => {
    const [file, setFile] = useState<File>()
    const [fileKey, setFileKey] = useState(Date.now())
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [summary, setSummary] = useState<Summary>()

    const ability = defineAbilityFor(getAuthUser())

    if (!ability.can('Upload', 'SupplierData')) {
        return <InsufficientPermissions />
    }

    const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        setIsSubmitting(true)

        if (file) {
            const form = new FormData()
            form.append('file', file)

            uploadSupplierData(form)
                .then(response => {
                    toastSuccess('Upload Successful')
                    setIsSubmitting(false)
                    setFile(undefined)
                    setFileKey(Date.now())
                    setSummary(response.data.summary)
                })
                .catch(() => {
                    setIsSubmitting(false)
                })
        }
    }

    return (
        <div className='container'>
            <div className='row'>
                <div className='col-6'>
                    <h3>Supplier Data Upload</h3>
                    <form onSubmit={(e) => handleSubmit(e)}>
                        <input
                            className='form-control mb-3'
                            key={fileKey}
                            onChange={(e) => {
                                const { files } = e.target

                                if (files) {
                                    setFile(files[0])
                                }
                            }}
                            type='file'
                            required />
                        <button
                            className='btn btn-primary'
                            disabled={isSubmitting}
                            type='submit'>
                            <span className='pe-2'>Upload</span>
                            {isSubmitting && <Loading sm={true} />}
                        </button>
                    </form>
                </div>
                {summary &&
                    <div className='col-6'>
                        <table className='table'>
                            <thead>
                                <tr>
                                    <th>Upload Summary</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th>Filename</th>
                                    <td>{summary.filename}</td>
                                </tr>
                                <tr>
                                    <th>Total Suppliers in File</th>
                                    <td>{summary.totalSuppliers}</td>
                                </tr>
                                <tr>
                                    <th>New Suppliers Created</th>
                                    <td>{summary.newSupplierCount}</td>
                                </tr>
                                <tr>
                                    <th>Duplicates</th>
                                    <td>{summary.duplicateCount}</td>
                                </tr>
                                <tr>
                                    <th>Missing Phone</th>
                                    <td>{summary.missingPhoneCount}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                }
            </div>
        </div>
    )
}
